import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { applyWorkspaceTheme } from "@/lib/workspaceTheme";

// Applies the tenant's saved Workspace theme whenever it or the light/dark mode changes.
export default function WorkspaceThemeApplier() {
  const { tenant } = useAuth();
  const { theme } = useTheme();
  useEffect(() => {
    applyWorkspaceTheme(tenant?.theme, theme);
  }, [tenant?.theme, theme]);
  return null;
}
